module.exports = __webpack_public_path__ + "static/media/javascript.bf05ea21.svg";